import { Block } from 'slate';
import { isEnd } from '../end';
import isAtBeginning from '../isAtBeginning';

export default (params) => {
  const { editor, incomingBlock, focusBlock, focusBlockNodes } = params;

  const { nodes: incomingChildNodes } = incomingBlock;

  const nodesArray = incomingChildNodes.toArray();

  let textNodes = [];
  nodesArray.forEach((node) => {
    const { object } = node;
    if (object === 'text') {
      textNodes = [...textNodes, node];
    }
  });

  const paraBlock = Block.create({
    object: 'block',
    type: 'paragraph',
    nodes: textNodes,
  });

  /**
   * Inserting single line in empty para blocks
   */
  const focusBlocksNodesArr = focusBlockNodes.toArray();
  const focusBlockParent = editor.value.document.getParent(focusBlock.key);
  const isFocusAtEnd = isEnd({ editor });
  const isFocusAtBeginning = isAtBeginning(editor);

  if (
    focusBlock.type === 'paragraph' &&
    focusBlockParent.type === 'list_item'
  ) {
    editor.withoutNormalizing(() => {
      if (!focusBlocksNodesArr[0].text) {
        editor.insertBlock(incomingBlock);
        const {
          value: { focusBlock: currFocusBlock },
        } = editor;
        const mergerKey = currFocusBlock.key;
        editor.mergeNodeByKey(mergerKey);
      } else {
        editor.insertBlock(incomingBlock);
      }
    });
    return true;
  }
  if (
    focusBlock.type === 'paragraph' &&
    focusBlockParent.type !== 'list_item'
  ) {
    editor.insertBlock(paraBlock);

    const {
      value: { focusBlock: currFocusBlock },
    } = editor;
    if (
      (focusBlocksNodesArr.length === 1 &&
        focusBlocksNodesArr[0].object === 'text' &&
        !focusBlocksNodesArr[0].text) ||
      isFocusAtEnd
    ) {
      const mergerKey = currFocusBlock.key;
      editor.mergeNodeByKey(mergerKey);
    } else if (isFocusAtBeginning) {
      editor.moveForward(1).deleteBackward(1);
    } else if (!isFocusAtBeginning && !isFocusAtEnd) {
      editor.mergeNodeByKey(currFocusBlock.key).deleteForward(1);
    }
    return true;
  }

  return false;
};
